import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SG_FETCH_EMAIL_LOG } from 'constants/actions';

export default function EmailDetails({ id }) {
  const dispatch = useDispatch();
  const email = useSelector((s) => s.action_email?.[id]);

  useEffect(() => {
    if (!email) dispatch({ type: SG_FETCH_EMAIL_LOG, payload: { id } });
  }, [dispatch, id, email]);

  if (!email) return <div>Loading...</div>;

  return (
    <div>
      <h2>Email log — {email.subject || email.id}</h2>
      <pre style={{ whiteSpace: 'pre-wrap' }}>{JSON.stringify(email, null, 2)}</pre>
    </div>
  );
}
